import { Helmet } from '@dr.pogodin/react-helmet';
import { useDispatch } from 'react-redux';
import { css, html } from 'react-strict-dom';
import { useForm } from 'react-typed-form';

import { Api, useApiFormSubmit } from '../../../api';
import { Avatar, Button, PageWrap, Text } from '../../../components';
import { Whitelabels } from '../../../constants';
import { useClientData } from '../../../contexts';
import { FieldCheckbox, FormWrap } from '../../../form';
import { ProfileTabs } from '../components';

export default function ProfilePage() {
  const { user } = useClientData();
  const dispatch = useDispatch();
  const whitelabel = Whitelabels.getWhitelabel();

  const formSubmit = useApiFormSubmit('PUT', `/users/${user.id}`, {
    onSuccess: () => {
      window.location.reload();
    },
  });
  const form = useForm<Api.User.W_partial>({
    defaultValues: {},
    pristineValues: user,
    onSubmit: formSubmit,
  });

  return (
    <PageWrap limitWidth="small">
      <Helmet>
        <title>Profile</title>
      </Helmet>

      {/* Time is only ever logged by the agency, so clients get no tabs. */}
      {user.agencyRole && <ProfileTabs selected="profile" />}

      <html.div style={styles.top}>
        <Avatar user={user} size={120} style={styles.avatar} />
        <Text as="p" style={styles.name}>
          {user.firstName} {user.lastName}
        </Text>
        <html.a
          style={styles.logOut}
          onClick={() => dispatch({ type: 'LOGOUT' })}
        >
          <Text style={styles.logOut}>Sign out</Text>
        </html.a>
      </html.div>

      <Text as="h2" style={styles.header}>
        Account
      </Text>
      <Text as="p">
        Email:{' '}
        <Text as="b" bold>
          {user.email}
        </Text>
      </Text>
      <Text as="p">
        To change your email, request a password reset, or for any other account
        queries, contact{' '}
        <html.a
          href={`mailto:${whitelabel.accountContact}`}
          style={styles.contact}
        >
          <Text style={styles.contact}>{whitelabel.accountContact}</Text>
        </html.a>
        .
      </Text>

      <Text as="h2" style={styles.header}>
        Notifications {/* Defaults */}
      </Text>
      <FormWrap {...form}>
        <html.div style={styles.notificationRow}>
          <html.label>
            <html.input type="checkbox" checked={true} disabled={true} />{' '}
            <Text>
              Notify me when someone replies to a ticket I participated in
            </Text>
          </html.label>
        </html.div>
        <html.div style={styles.notificationRow}>
          <html.label>
            <FieldCheckbox field={form.getField('notifyTicket')} />{' '}
            <Text>
              Notify me when someone creates or replies to any ticket in one of
              my companies
            </Text>
          </html.label>
        </html.div>
        <Button
          label="Save changes"
          onClick={form.handleSubmit}
          disabled={form.isLoading}
        />
      </FormWrap>
    </PageWrap>
  );
}

const styles = css.create({
  top: {
    marginBlock: 30,
    marginInline: 0,
    textAlign: 'center',
  },
  avatar: {
    marginBottom: 15,
  },
  name: {
    fontSize: 18,
    marginBottom: 2,
    color: '#333',
  },
  logOut: {
    fontSize: 14,
    color: 'inherit',
  },
  contact: {
    color: 'inherit',
  },
  header: {
    fontWeight: '400',
    fontSize: 26,
    marginTop: 50,
    marginBottom: 20,
    marginInline: 0,
    paddingTop: 0,
    paddingBottom: 2,
    paddingInline: 0,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#ddd',
    color: '#333',
  },
  notificationRow: {
    marginBottom: 12,
  },
});
